<template>
	<div class="fd-suggester fd-suggester-touch" :class="extraClasses">
		<swipe-row v-for="(item, index) in tagArray" :key="item.key">
			<tag-part
				:name="item.name"
				:icon="item.icon"
				:href="item.href"
				:title="item.title"
				:index="index"
				:disabled="ro"
				class="fd-suggester-tag chevron"
				@click.prevent.stop="openSuggestion(index)"></tag-part>
			<template #actions v-if="!ro"><swipe-action icon="trash" @click.prevent.stop="deleteTag(index)"></swipe-action></template>
		</swipe-row>
		<div v-if="canAddMoreTags" class="fd-suggester-add chevron" @click.prevent.stop="addTag">
			{{ env.msg("select") }}
		</div>
	</div>
</template>

<script setup lang="ts">
import TagPart from "./TagPart.vue";
import SwipeRow from "../../helpers/SwipeRow.vue";
import SwipeAction from "../../helpers/SwipeAction.vue";
import useSuggester, {type SuggesterProps, suggesterProps} from "./Suggester";
import {computed} from "vue";
import {injectEnv} from "../../Environment";
import type {PanelDescriptor} from "../../Types";
import type {Suggester} from "@t/fd/editor/Suggester";


const uprops = defineProps({ ...suggesterProps });
const props = uprops as SuggesterProps;

const emit = defineEmits(["suggested"]);

const sg:Suggester = props.part as Suggester;

const env = injectEnv();
const { visible, value, clazz, style, ro, tagArray, canAddMoreTags, prop, getPropertyIdValue,
  deleteData, dataObjectAt, valueEmpty, propagateSuggestion, buildSuggesterUrl } = useSuggester(props, env);

const extraClasses = computed(() => {
  let c = [];
  if (ro.value) c.push("fd-suggester-disabled");
  return c;
});
const pickerLabel = computed(() => {
  if (sg.pickerLabel) return sg.pickerLabel;
  return env.msg("pickerLabel");
});


function openSuggestion(index:number) {
  if (!sg.srcType) return; // clicking isn't supported
  let srcIdProps;
  if (Array.isArray(sg.srcIdProperty)) srcIdProps = sg.srcIdProperty;
  else srcIdProps = [prop.value];

  for (let prop of srcIdProps) {
    if (prop) {
      let id = getPropertyIdValue(prop, index);
      if (id !== null) {
        env.navigateTo(sg.srcType, id);
        break;
      }
    }
  }
}

function deleteTag(idx:number):void {
  const tagSegment = tagArray.value[idx];
  const dataIndex = tagSegment.index;
  deleteData(dataIndex);
}

function addTag() {
  const tagIndex = tagArray.value.length;
  const pg:PanelDescriptor = {
    component: "suggester-panel",
    title: pickerLabel.value,
    search: true,
    bind: {
      url: buildSuggesterUrl(tagIndex),
      suggester: sg.suggester,
    }
  };
  env.showPanel(pg)
      .then((result)=> {
        if (result !== undefined) {
          propagateSuggestion(result, tagIndex);
        }
      });
}
</script>

<style>
.fd-suggester-touch,
.fd-suggester-add {
	min-height: calc(1em + 16px);
}
.fd-suggester-touch .fd-tag,
.fd-suggester-add {
	padding: 8px 0;
}
.fd-suggester-add {
	color: var(--active);
	text-transform: lowercase;
	position: relative;
}
.fd-suggester-empty-label {
	color: var(--inactive, #999999);
	width: 100%;
}
</style>
